var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBeverages(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 65.274,
    height: 104.151,
    viewBox: "0 0 65.274 104.151",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons-02",
    transform: "translate(-112.5 -49.434)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_47",
    "data-name": "Path 47",
    d: "M133.5,71.589,132.975,56.7a1.34,1.34,0,0,1,.67-1.273V52.078l-.67-.449V50.564c-.968-1.273-4.632-1.125-4.632-1.125s-3.664-.151-4.625,1.125v1.048l-.67.449V55.41a1.34,1.34,0,0,1,.67,1.273L123.2,71.572a63.254,63.254,0,0,1-6.437,21.993s-4.26,7.632-4.26,20.874v34.129s0,3.218,2.766,3.969c0,0,3.737,1.048,13.084,1.048s13.091-1.048,13.091-1.048c2.77-.75,2.77-3.969,2.77-3.969V114.456c0-13.242-4.263-20.874-4.263-20.874A63.142,63.142,0,0,1,133.5,71.589Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48",
    "data-name": "Path 48",
    d: "M266.272,252.889a.359.359,0,0,0,.037-.154c0-.914-3.9-1.165-6.527-1.165s-6.53.251-6.53,1.165a.335.335,0,0,0,.044.157c-.67,1.624-3.778,9.377-2.95,13.563,0,0,.764,4.323,7.542,6.286A5.986,5.986,0,0,1,259,275.106s.7,3.724-.834,5.094c-2.217.288-4.062.7-4.062.7s1.587-.224,3.62-.335a2.927,2.927,0,0,1-.626.4s2.009-.208,2.482-3.463a7.4,7.4,0,0,0-.737-4.689c.3,0,.616.027.938.027s.67,0,1-.03a8.741,8.741,0,0,0-.71,4.689c.335,3.255,2.472,3.463,2.472,3.463a3.067,3.067,0,0,1-.67-.4c2.076.1,3.751.335,3.751.335a32.247,32.247,0,0,0-4.253-.717c-1.5-1.383-.814-5.077-.814-5.077a5.95,5.95,0,0,1,1.115-2.361c6.778-1.959,7.549-6.293,7.549-6.293C270.046,262.273,266.945,254.507,266.272,252.889Zm-6.49-1.175c3.788,0,6.212.566,6.249.961h0v.02c-.044.4-2.411.958-6.249.958s-6.256-.573-6.256-.971S255.964,251.714,259.781,251.714Zm0,19.759c-6.651,0-9.082-3.774-9.146-7.006-.054-2.743,2.127-9.514,2.766-11.443.737.713,4.059,1.058,6.38,1.058s5.6-.335,6.363-1.045c.549,1.674,2.8,8.654,2.8,11.785C268.947,267,266.707,271.473,259.781,271.473Z",
    transform: "translate(-91.588 -134.442)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49",
    "data-name": "Path 49",
    d: "M273.938,341.342c1.34,0,2.451.174,2.451-.131s-1.1-.931-2.451-.931-2.448.626-2.448.931S272.585,341.342,273.938,341.342Z",
    transform: "translate(-105.745 -193.443)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50",
    "data-name": "Path 50",
    d: "M264.066,346.745c-4.1,0-7.418-1.109-7.418-.737a.177.177,0,0,0,0,.04c.854.613,2.827,1.363,7.368,1.363h.09c4.545,0,6.514-.75,7.368-1.363C271.393,345.717,268.108,346.745,264.066,346.745Z",
    transform: "translate(-95.873 -197.203)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeverages);
export default __webpack_public_path__ + "static/media/beverages.523f0db9c27508880c2827b2837097a8.svg";
export { ForwardRef as ReactComponent };